import { FILLED_OPTION_SHADOW_ID } from './constants';
export var hasOptionBeenFilled = function hasOptionBeenFilled(option) {
  return option.id === FILLED_OPTION_SHADOW_ID;
};
export default hasOptionBeenFilled;